/* eslint-disable react/prop-types */
import React, {Component} from 'react';

import {isEqual} from 'lodash';
import {connect} from 'react-redux';

import * as loadingActions from '@/actions/loadingActions';
import * as setupActions from '@/actions/setupActions';
import {
  getCycleParamDevice,
  postPauseSeqDesignerDevice,
  postResumeSeqDesignerDevice,
  postStartSeqDesignerDevice,
  postStopSeqDesignerDevice,
} from '@/api/deviceApi';
import HelpIcon from '@/assets/icons/Question.svg';
import PopUpWizard from '@/components/popup/PopUpWizard';
import * as APPDATA from '@/constants/pcConstAppData';
import {EventLicenseService} from '@/constants/pubSubEnum';
import * as PC_COMMON_FUNCTION from '@/libs/appHelper';
import {consoleLog} from '@/libs/consoleHelper';
import {eventBusObject} from '@/observers/eventBus';

import {findSequenceIndex} from './business/commonFunction';
import {ConvertSequenceToBackendParam} from './business/pressureContent';
import {RepeatModeCheck} from './business/sequenceContent';
import {DataHelp} from './help/ManualProfileHelp';
// eslint-disable-next-line import/no-cycle
import SequenceBuilder from './SequenceBuilder';
// eslint-disable-next-line import/no-cycle
import SequenceConfiguration from './SequenceConfigurations';

export const VIEW_MODE = {
  DESIGNER: 'DESIGNER',
  CONFIGURATION: 'CONFIGURATION',
};

@connect((store) => ({
  fontSize: store.setupStore.fontSize,
  isManualProfileRunning: store.setupStore.isManualProfileRunning,
  isManualProfilePaused: store.setupStore.isManualProfilePaused,
  defaultPressureTemplate: store.setupStore.defaultPressureTemplate,
  CustomOperation: store.setupStore.CustomOperation,
}))
class ManualProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewMode: VIEW_MODE.DESIGNER,
      isHelpModeEnable: false,
    };

    this._bus = eventBusObject();
  }

  componentDidMount() {
    const {CustomOperation, dispatch} = this.props;
    const {viewMode} = this.state;

    dispatch(setupActions.updateActiveMenu(APPDATA.PAGE_MENU.MANUAL_PROFILE));
    this.checkOperationActivated([...CustomOperation.Operations], viewMode);
    getCycleParamDevice();
  }

  componentDidUpdate(prevProps, prevState) {
    const {CustomOperation, isManualProfileRunning, isManualProfilePaused} = this.props;
    const {Operations, FileName} = CustomOperation;
    const {viewMode} = this.state;

    if (
      !isEqual(Operations, prevProps.Operations) ||
      FileName !== prevProps.FileName ||
      viewMode !== prevState.viewMode ||
      isManualProfileRunning !== prevProps.isManualProfileRunning ||
      isManualProfilePaused !== prevProps.isManualProfilePaused
    ) {
      this.checkOperationActivated([...CustomOperation.Operations], viewMode); // TODO: this is temporary solution, need to break down this component into separate component because this component logic is too general that includes of controlling the top menu and controlling the content state, when refactoring this component should applying the component lifecycle to improve the performance
    }
  }

  // TODO: need to refactor this component since the component has props drilling behavior usage to generate other component, please carefull since top menu has other generator in some components that could be difference or could be the same
  /**
   * Top Menu Porps
   * @param {Boolean} disableMainButton
   */
  setTopMenuProperties = (disableMainButton) => {
    const {isManualProfileRunning, isManualProfilePaused, CustomOperation} = this.props;
    const maxSequenceName = 8;
    let sequenceName = '';

    if (CustomOperation.FileName != null) {
      sequenceName = ` - ${CustomOperation.FileName}`;
      if (sequenceName.length > maxSequenceName) sequenceName = `${sequenceName.substring(0, maxSequenceName)}...`;
    }

    const runButtonProperties = {
      id: APPDATA.RUN,
      label: APPDATA.RUN,
      onClick: this.onClickTopMenu,
      disabled: disableMainButton,
    };
    const stopButtonProperties = {
      id: APPDATA.STOP,
      label: APPDATA.STOP,
      onClick: this.onClickTopMenu,
      disabled: disableMainButton,
      className: ' stop-button ',
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: isManualProfileRunning,
      onClick: this.onClickTopMenu,
    };

    const disablePauseStopButton = !isManualProfileRunning;
    const ButtonPauseProps = {
      id: 'PAUSE',
      label: 'PAUSE',
      onClick: this.onClickTopMenu,
      disabled: disablePauseStopButton,
      className: ' pause-button ',
    };
    const ButtonContinueProps = {
      id: 'CONTINUE',
      label: 'CONTINUE',
      onClick: this.onClickTopMenu,
      disabled: disablePauseStopButton,
      className: ' resume-button ',
    };
    const titleMenuProperties = APPDATA.MANUAL_PROFILE.toUpperCase() + sequenceName;
    const manualProfileHelperSecondaryButton = {
      id: 'manualProfileHelp',
      onClick: this.onClickHelp,
      className: 'help-icon',
      icon: HelpIcon,
      disabled: false,
    };

    if (isManualProfileRunning) {
      const pauseresumebutton = isManualProfilePaused ? ButtonContinueProps : ButtonPauseProps;
      this.setDoubleTopMenuProperties(
        pauseresumebutton,
        stopButtonProperties,
        backButtonProperties,
        titleMenuProperties,
        manualProfileHelperSecondaryButton,
      );
    } else {
      this.setupTopMenuProperties(
        runButtonProperties,
        backButtonProperties,
        titleMenuProperties,
        manualProfileHelperSecondaryButton,
      );
    }
  };

  setTopMenuPropertiesConfiguration = ({onClickDefault, parameterChanged}) => {
    const topButtonProperties = {
      id: APPDATA.RUN,
      label: APPDATA.RUN,
      onClick: this.onClickTopMenu,
      disabled: true,
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: parameterChanged,
      onClick: onClickDefault,
    };
    const titleMenuProperties = APPDATA.MANUAL_PROFILE.toUpperCase();
    const manualProfileHelperSecondaryButton = {
      id: 'manualProfileHelp',
      onClick: this.onClickHelp,
      className: 'help-icon',
      icon: HelpIcon,
      disabled: false,
    };

    this.setupTopMenuProperties(
      topButtonProperties,
      backButtonProperties,
      titleMenuProperties,
      manualProfileHelperSecondaryButton,
    );
  };

  setupTopMenuProperties = (
    topButtonProperties,
    backButtonProperties,
    titleMenuProperties,
    topButtonSecondaryButtonProperties,
  ) => {
    const {dispatch} = this.props;

    dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
        topButtonSecondaryButtonProperties,
      }),
    );
    dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };

  setDoubleTopMenuProperties = (
    button1Properties,
    button2Properties,
    backButtonProperties,
    titleMenuProperties,
    secondaryButton,
  ) => {
    const {dispatch} = this.props;

    dispatch(
      setupActions.setDoubleTopMenuProperties({
        button1Properties:
          button1Properties === undefined
            ? undefined
            : {
                id: button1Properties.id,
                label: button1Properties.label,
                onClick: button1Properties.onClick,
                disabled: button1Properties.disabled,
                className: button1Properties.className,
                enableLongPress: button1Properties.enableLongPress,
                endLongPress: button1Properties.endLongPress,
                startLongPress: button1Properties.startLongPress,
              },
        button2Properties:
          button2Properties === undefined
            ? undefined
            : {
                id: button2Properties.id,
                label: button2Properties.label,
                onClick: button2Properties.onClick,
                disabled: button2Properties.disabled,
                className: button2Properties.className,
              },
        backButtonProperties: {
          id: backButtonProperties.id,
          label: '',
          disabled: backButtonProperties.disabled,
          onClick: backButtonProperties.onClick,
        },
        titleMenuProperties,
        topButtonSecondaryButtonProperties: secondaryButton,
      }),
    );
    dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };

  onClickHelp = () => {
    this.setState({
      isHelpModeEnable: true,
    });
  };

  onClickTopMenu = (e) => {
    const {isManualProfileRunning, isManualProfilePaused, CustomOperation, dispatch, defaultPressureTemplate} =
      this.props;

    switch (e.currentTarget.id) {
      case APPDATA.RUN: {
        let sequenceParam = {
          Repeat: CustomOperation.Repeat,
          Operations: [...CustomOperation.Operations],
          [APPDATA.KEY.ChipValve]: CustomOperation.ChipValve,
          IsDepressurizedAtTheEnd: 'true',
        };
        sequenceParam = RepeatModeCheck(sequenceParam);
        sequenceParam = ConvertSequenceToBackendParam(sequenceParam, defaultPressureTemplate);

        postStartSeqDesignerDevice(sequenceParam).then(() => {
          dispatch(setupActions.updateIsManualProfileRunning(true));
          dispatch(setupActions.updateIsManualProfilePaused(false));
          this._bus.publish(EventLicenseService.TrialLicenseDayLeftInfoService, {});
        });

        break;
      }
      case 'PAUSE':
        if (isManualProfileRunning && !isManualProfilePaused) {
          postPauseSeqDesignerDevice().catch(() => dispatch(loadingActions.showLoading(false)));
        }
        break;

      case 'CONTINUE':
        consoleLog('CONTINUE clicked', {isManualProfileRunning, isManualProfilePaused});
        if (isManualProfileRunning && isManualProfilePaused) {
          postResumeSeqDesignerDevice();
        }
        break;

      case APPDATA.BACK:
        window.location.href = APPDATA.HOME_SCREEN_ADDRESS;

        break;

      case APPDATA.STOP:
        postStopSeqDesignerDevice().catch(() => {
          dispatch(setupActions.showAlert({alertShow: false}));
        });
        break;
      default:
        break;
    }
  };

  /**
   * @param {*} newOperations
   */
  operationsUpdate = (newOperations) => {
    const {dispatch} = this.props;

    dispatch(setupActions.UpdateOperationList(newOperations));
    dispatch(setupActions.SetCustomOperationContentChanged(true));
  };

  /**
   * @param {*} operations
   */
  checkOperationActivated = (operations = [], viewMode = '') => {
    const findActiveOperations = operations.find((op) => op.Active);

    if (operations.length === 0 || !findActiveOperations || viewMode === VIEW_MODE.CONFIGURATION) {
      this.setTopMenuProperties(true);
    } else {
      this.setTopMenuProperties(false);
    }
  };

  // param
  // viewMode :VIEW_MODE.CONFIGURATION,
  // operationId : selectedSequenceId
  //
  viewModeUpdate = (newViewModeParams) => {
    const {CustomOperation} = this.props;

    const newViewMode = newViewModeParams.viewMode;
    const selectedSequenceId = newViewModeParams.operationId;
    const indexUpdated = findSequenceIndex([...CustomOperation.Operations], selectedSequenceId);

    this._tempSelectedIndexConfig = indexUpdated;
    this.setState({
      viewMode: newViewMode,
    });

    switch (newViewMode) {
      case VIEW_MODE.DESIGNER:
        // this.checkTopMenuButtonProps([...CustomOperation.Operations]);
        break;
      case VIEW_MODE.CONFIGURATION:
        break;
      default:
        break;
    }
  };

  saveConfigProps = (selectedSequenceId, newSequenceConfig) => {
    const {CustomOperation} = this.props;

    const indexDeleted = findSequenceIndex([...CustomOperation.Operations], selectedSequenceId);
    const newOperations = PC_COMMON_FUNCTION.createNewJsonObject([...CustomOperation.Operations]);
    newOperations[indexDeleted] = newSequenceConfig;

    this.operationsUpdate(newOperations);
  };

  onChangeRepeatAll = (e) => {
    const {dispatch} = this.props;

    dispatch(setupActions.SetCustomOperationContentChanged(true));
    dispatch(setupActions.SetCustomOperationRepeatValue(e.value));
  };

  //-----------------
  finishAction = (e) => {
    const dataAlert = {
      message: 'aaa',
      style: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
    };

    if (!e) {
      dataAlert.style = APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER;
      dataAlert.message = 'The Sequence has been stopped!';
    } else if (!e.message) {
      // success
      dataAlert.style = APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS;
      dataAlert.message = 'The Sequence has been finished!';
    } else {
      // failed
      dataAlert.style = APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER;
      dataAlert.message = e.message;
    }
    if (dataAlert.message) this.showAlert(dataAlert);
  };

  showAlert = (props) => {
    const {dispatch} = this.props;

    dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: props.message,
        alertStyle: props.style,
      }),
    );
  };

  onClosePopUpWizard = () => {
    this.setState({
      isHelpModeEnable: false,
    });
  };

  render() {
    const {CustomOperation, fontSize} = this.props;
    const {viewMode, isHelpModeEnable} = this.state;

    const view =
      viewMode === VIEW_MODE.DESIGNER ? (
        <SequenceBuilder
          onChangeOperations={this.operationsUpdate}
          changeViewMode={this.viewModeUpdate}
          onChangeRepeatAll={this.onChangeRepeatAll}
          finishCallBack={this.finishAction}
        />
      ) : (
        <SequenceConfiguration
          sequence={[...CustomOperation.Operations][this._tempSelectedIndexConfig]}
          onChangeOperations={this.operationsUpdate}
          changeViewMode={this.viewModeUpdate}
          saveConfigProps={this.saveConfigProps}
          topMenuProps={this.setTopMenuPropertiesConfiguration}
        />
      );
    const style = {
      constraint: {
        fontSize,
      },
    };

    return (
      <>
        <div
          className="ManualProfile"
          style={style.constraint}
        >
          {view}
        </div>
        <PopUpWizard
          data={DataHelp}
          fontSize={fontSize}
          popUpWizardVisible={isHelpModeEnable}
          onClose={this.onClosePopUpWizard}
        />
      </>
    );
  }
}
export default ManualProfile;
